import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FixedBottom } from '../../ui';
import Logo from '../../ui/assets/logo.png';
import { versionService } from '../../store/services';
import { PersonOutline, ShoppingCartOutlined, FolderCopyOutlined, StoreOutlined, Circle } from '@mui/icons-material';


const version = require('../../../package.json').version;

const menuItems = [
    {
        label: 'Profilo',
        path: '/profile',
        icon: <PersonOutline fontSize='large' />,
    },
    {
        label: 'shop',
        path: '/shop',
        icon: <StoreOutlined fontSize='large' />,
    },
    {
        label: 'Kangury',
        path: '/',
        icon: 'fa-wifi'
    },
    {
        label: 'Album',
        path: '/album-list',
        icon: <FolderCopyOutlined fontSize='large' />,
    },
    {
        label: 'Carrello',
        path: '/cart',
        icon: <ShoppingCartOutlined fontSize='large' />,
    }
];

export function BottomNavigation() {
    const page = window.location.pathname;
    const navigate = useNavigate();
    const lockButtonsRef = React.useRef(page === '/cart');

    const [showUpdateAlert, setShowUpdateAlert] = React.useState(false);
    React.useEffect(() => {
        versionService.get().then((response) => {
            const value = response.value
            if (value !== version) {
                setShowUpdateAlert(true);
            }
        });
    }, [])

    React.useEffect(() => {
        if (lockButtonsRef.current) {
            // disable navigation buttons for 1 second if in cart to avoid double click
            setTimeout(() => {
                lockButtonsRef.current = false;
            }, 500);
        }
    }, [page]);

    const handleCardClick = (path) => {
        if (lockButtonsRef.current) return;
        navigate(path);
    }

    return (
        <FixedBottom>
            <div className="row w-100">
                {menuItems.map((item) => (
                    item.path === '/' ?
                        <div className="col position-relative" key={item.label}>
                            <button className={`btn btn btn-primary text-capitalize rounded-circle position-absolute start-50 m-0 translate-middle-x bottom-0 z-1000 bg-tertiary${page === item.path ? " text-primary" : " text-white z-1000"}`} key={item.label} onClick={() => handleCardClick(item.path)} style={{ width: '80px', height: '80px' }}>
                                <img src={Logo} alt="logo" className='w-100' />
                            </button>
                        </div>
                        :
                        <button className={`col btn text-capitalize d-flex flex-column align-items-center position-relative justify-content-center m-0${page === item.path ? " text-primary" : " text-dark"}`} key={item.label} onClick={() => handleCardClick(item.path)}>
                            {item.icon}
                            {showUpdateAlert && item.path === '/profile' &&
                                <Circle fontSize='small'
                                    className='position-absolute end-0 top-0 z-1000 mt-1 me-2 text-primary' />}
                            <span>{item.label}</span>
                        </button>
                )
                )}
            </div>
        </FixedBottom>
    );
}